import React from 'react';
import PropTypes from 'prop-types';

import Group from '../../../../components/Group';
import Row from '../../../../components/Row';
import Value from '../../../../components/Value';
import MembershipPresenter from '../../../../presenters/FastCash/MembershipPresenter';
import CurrencyPresenter from '../../../../presenters/CurrencyPresenter';

const GeneralInfo = (props) => {
  const { meta, currentMembership } = props;
  const latestMembershipState =
    MembershipPresenter.stateReadable(currentMembership);

  const { paymentsTotalAmount, bonusesTotalAmount, userEmail } = meta;

  return (
    <Group title="General Info">
      <Row>
        <Value attr="userEmail" title="User email">
          {userEmail}
        </Value>
        <Value attr="latestMembershipState" title="Current membership state">
          {latestMembershipState}
        </Value>
      </Row>
      <Row>
        <Value attr="totalAmountOfPayments" title="Total amount of payments">
          {CurrencyPresenter.formatDollarAmount(paymentsTotalAmount)}
        </Value>
        <Value attr="totalAmountOfBonuses" title="Total amount of bonuses">
          {CurrencyPresenter.formatDollarAmount(bonusesTotalAmount)}
        </Value>
      </Row>
    </Group>
  );
};

export default GeneralInfo;

GeneralInfo.propTypes = {
  meta: PropTypes.shape({}).isRequired,
  currentMembership: MembershipPresenter.shape().isRequired,
};
